import React from "react";
import ReactDOM from  "react-dom";
import { wrapCurrentUser } from "../../mixins/wrap_current_user";
import { logout } from "../../util/login";
import Template from "./metype_home.rt";
import { subscribePlan, createAccount } from "../../gateway/backend";
import { CombinedReducerStore } from "../../store";

@wrapCurrentUser
export default class Home extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      toggleListComponent: false,
      openContactUsModal: false,
      accountSignupModal: false,
      disableGetStartedButton: false,
      selectedPlans:[],
      spinner: false,
    }

    this.toggleContactUs = this.toggleContactUs.bind(this);
    this.getSubscription = this.getSubscription.bind(this);
    this.toggleAccountSignupModal = this.toggleAccountSignupModal.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.getFreePlan = this.getFreePlan.bind();
    this.closeAccountSignUpModal = this.closeAccountSignUpModal.bind(this);
  }

  getFreePlan(){
    return talktype.config.plans ? talktype.config.plans.find( plan => plan.name === "Standard") : {};
  }

  handleChange(e) {
    this.setState({[e.target.name]: e.target.value});
  }

  userLogin() {
    if(this.state.action === 'getStarted') {
      this.setState({ accountSignupModal: true, toggleListComponent: !this.state.toggleListComponent});
    }else {
      document.body.style.overflow = 'auto';
      this.setState({accountSignupModal: false, toggleListComponent: !this.state.toggleListComponent})
    }
  }

  closeAccountSignUpModal() {
    document.body.style.overflow = 'auto';
    this.setState({accountSignupModal: false, selectedPlans: []})
  }

  toggleListComponent(action = "") {
    document.body.style.overflow = 'hidden';
    if(action === 'getStarted') {
      this.props.signedIn ? this.setState({toggleListComponent: false, accountSignupModal: true})
                             : this.setState({toggleListComponent: true, accountSignupModal: false, action: action})
    }
    else {
      this.setState({toggleListComponent: true, accountSignupModal: false, action: action});
    }
  }

  closeLogin(loginObj={}) {
    CombinedReducerStore.dispatch({type: 'LOGIN', ...loginObj, email: "", password: ""});
    CombinedReducerStore.dispatch({type: 'SCREEN', screen: 'signin'});
    CombinedReducerStore.dispatch({type: 'ERRORS', errors: {}});
    this.setState({toggleListComponent: !this.state.toggleListComponent, accountSignupModal: false, spinner: false});
    document.body.style.overflow = "auto";
  }

  toggleContactUs() {
    this.setState({openContactUsModal: !this.state.openContactUsModal}, () => this.toggleScroll());
  }

  toggleAccountSignupModal(planName) {
    this.toggleListComponent("getStarted")
    if(planName) {
      var planeDetails= talktype.config.plans ? talktype.config.plans.find( plan => plan.name === planName) : {};

      if (planeDetails===undefined) {
          planeDetails=[];
      }
      planeDetails['count']=Object.keys(planeDetails).length;
      this.setState({
        selectedPlans: planeDetails,
        accountSignupModal: true
      }, () => this.toggleScroll());
    }
  }

  toggleScroll() {
    if((this.state.openContactUsModal || this.state.accountSignupModal)) {
      document.body.classList.add("scroll-disable");
    }
    else {
      document.body.classList.remove("scroll-disable");
    }
  }

  onSubmit(event, accountDetails, planValues) {
    if(this.state.disableGetStartedButton) return false;
    const form = event.target.parentElement;
    if(form.checkValidity()) {
      event.preventDefault();
      event.stopPropagation();
      this.setState({disableGetStartedButton: true , spinner: !this.state.spinner });
      this.getSubscription(planValues, accountDetails);
    }
  }

  getSubscription({name, id, price}, accountDetails) {
      subscribePlan(this.props.currentUser.id)
      .then((response)=> this.createAccount(response, accountDetails));
  }

  createAccount(response, accountDetails) {
    const accountDetailsRazorpayIds = {...accountDetails, subscription_id: response["id"]};
    createAccount(this.props.currentUser.id, accountDetailsRazorpayIds)
    .then(() => {
      this.redirectToAdminPage();
    });
  }

  redirectToAdminPage() {
    window.location.href = "/admin";
  }

  focusDiv(event) {
    if(event.target.id == 'metype-header-menubar-features') {
       window.location.href="#features";
     }
    else if(event.target.id == 'metype-header-menubar-pricing') {
      window.location.href="#pricing";
    }
  }

  signOut(loginObj={}) {
    logout();
  }

  redirectLink() {
    return ((this.props.currentUser.accounts) ? '/admin' : '/dashboard');
  }

  render() {
    return Template.call(this);
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pages/metype_home/metype_home.js